import * as tslib_1 from "tslib";
import { takeUntil } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { ContainerBase } from '../../../core/base/container-base';
import * as products from '../../actions/product';
import * as cart from '../../../cart/actions/cart';
import * as fromCart from '../../../cart/reducers';
import * as fromCatalog from '../../reducers';
import * as fromAuth from '../../../auth/reducers';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import chaining from '../../../core/helpers/chaining';
import * as fromBase from '../../../base/reducers';
var DetailsContainer = /** @class */ (function (_super) {
    tslib_1.__extends(DetailsContainer, _super);
    function DetailsContainer(activeModal, store) {
        var _this = _super.call(this) || this;
        _this.activeModal = activeModal;
        _this.store = store;
        _this.currentDate = new Date().toISOString();
        _this.allowOutOfStockOrdering = false;
        _this.detailsPageSettings$ = _this.store.pipe(select(fromBase.getItemDetailsPageSettings), takeUntil(_this.destroyed$));
        _this.loading$ = store
            .pipe(select(fromCatalog.isDetailsLoading), takeUntil(_this.destroyed$));
        _this.product$ = store
            .pipe(select(fromCatalog.getSelectedProduct), takeUntil(_this.destroyed$));
        _this.selectedProductOrderHistory$ = store
            .pipe(select(fromCatalog.getSelectedProductOrderHistory), takeUntil(_this.destroyed$));
        _this.selectedProductBackorders$ = store
            .pipe(select(fromCatalog.getSelectedProductBackorders), takeUntil(_this.destroyed$));
        _this.favoritesProducts$ = _this.store
            .pipe(select(fromCatalog.getFavorites), takeUntil(_this.destroyed$));
        _this.stock$ = store
            .pipe(select(fromCatalog.getStock), takeUntil(_this.destroyed$));
        _this.skus$ = store
            .pipe(select(fromCatalog.getSKUs), takeUntil(_this.destroyed$));
        _this.cartProducts$ = store
            .pipe(select(fromCart.getCartProducts), takeUntil(_this.destroyed$));
        _this.orderLines$ = store
            .pipe(select(fromCart.getCurrentOrderLines), takeUntil(_this.destroyed$));
        _this.orderLines$
            .subscribe(function (orderLines) { return _this.orderLines = orderLines; });
        _this.combinedFacets$ = store
            .pipe(select(fromCatalog.getCombinedFacets), takeUntil(_this.destroyed$));
        _this.quantityPicker$ = store
            .pipe(select(fromBase.getQuantityPicker), takeUntil(_this.destroyed$));
        _this.store.pipe(select(fromAuth.getUserPermissions), takeUntil(_this.destroyed$)).subscribe(function (permissions) {
            _this.showSalesOrderPriceInfo = permissions.indexOf('VIEW_SALESORDER_PRICE_INFO') > -1;
        });
        _this.store.pipe(select(fromAuth.getUserPermissions), takeUntil(_this.destroyed$)).subscribe(function (permissions) {
            // First check if user is allowed to see stock info. If not, allowOutOfStockOrdering should be true since no stock info is available
            if (permissions.indexOf('VIEW_STOCK_INFO') === -1) {
                _this.allowOutOfStockOrdering = true;
            }
            else {
                // User is allowed to see stock. Check for ALLOW_OUT_OF_STOCK_ORDERING permission.
                if (permissions.indexOf('ALLOW_OUT_OF_STOCK_ORDERING') > -1) {
                    _this.allowOutOfStockOrdering = true;
                }
            }
            if (permissions.indexOf('DOWNLOAD_IMAGES') > -1) {
                _this.canDownloadImage = true;
            }
        });
        return _this;
    }
    DetailsContainer.prototype.toggleFavorite = function (event) {
        event.isFavorite
            ? this.store.dispatch(new products.RemoveFavorite(event.product))
            : this.store.dispatch(new products.AddFavorite(event.product));
    };
    DetailsContainer.prototype.onClose = function () {
        this.activeModal.dismiss();
    };
    DetailsContainer.prototype.addCart = function (event) {
        var orderLineId = chaining(this.orderLines.find(function (line) { return chaining(line, 'product._id') === chaining(event, 'product'); }), '_id');
        if (chaining(event, 'quantity') > 0) {
            this.store.dispatch(new cart.Add({
                product: event.product,
                quantity: event.quantity
            }));
        }
        else if (event.quantity <= 0 && orderLineId)
            this.store.dispatch(new cart.Remove({
                lineId: orderLineId
            }));
    };
    return DetailsContainer;
}(ContainerBase));
export { DetailsContainer };
